import { call, CallEffect, put, PutEffect, select, SelectEffect } from 'redux-saga/effects';
import { getSearchAnalyticsData } from 'b2b-apps/core/analytics/redux';
import { analyzeEvent } from 'b2b-apps/core/analytics/redux/tealium/actionCreators';
import { TEALIUM_INTERACTION_ID, TEALIUM_PROD_ACTION, TEALIUM_PROD_LIST } from 'b2b-apps/core/analytics/types/types';
import { getSearch } from 'b2b-apps/core/catalog/redux/search/selectors';
import { CatalogSearchType } from 'b2b-apps/core/catalog/redux/search/types';
import { RemoteRecord } from 'b2b-apps/core/common/redux/RemoteRecord';
import { getProductTileBySku } from 'b2b-apps/core/product/redux/products/tile/selectors';
import { ProductTileType } from 'b2b-apps/core/product/redux/products/tile/types';

export function* analyzeSearchProductInteraction(
  interaction: TEALIUM_INTERACTION_ID,
  action: TEALIUM_PROD_ACTION,
  sku: string,
  quantity?: number,
): Generator<PutEffect | SelectEffect, void, RemoteRecord<CatalogSearchType> & RemoteRecord<ProductTileType>> {
  const searchRecord = yield select(getSearch);
  const search = searchRecord.data;
  const productTileRecord = yield select(getProductTileBySku, sku);
  const productTile = productTileRecord.data;

  if (!productTile || !search) {
    return null;
  }
  const { productsCount, query, requestedQuery: originalQuery } = search;


  yield put(analyzeEvent(
    getSearchAnalyticsData({
      id: interaction,
      query,
      originalQuery,
      productsCount,
      productsAction: action,
      productsList: TEALIUM_PROD_LIST.search,
      ...(quantity != null && { productQuantity: quantity }),
      products: [productTile],
    }),
  ));
}

export function* analyzeSearchProductClickInteraction(sku: string): Generator<CallEffect, void> {
  yield call(
    analyzeSearchProductInteraction,
    TEALIUM_INTERACTION_ID.productSearchListClick,
    TEALIUM_PROD_ACTION.productListClick,
    sku,
  );
}

export function* analyzeSearchProductAddToCartInteraction(sku: string): Generator<CallEffect, void> {
  yield call(
    analyzeSearchProductInteraction,
    TEALIUM_INTERACTION_ID.productSearchAddToCart,
    TEALIUM_PROD_ACTION.addToCartFromList,
    sku,
    1,
  );
}
